module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "获取二维码",
      "visible": _vm.formVisible,
      "width": "350px"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-select', {
    staticClass: "sels",
    attrs: {
      "placeholder": "选择方式"
    },
    model: {
      value: (_vm.showmods),
      callback: function($$v) {
        _vm.showmods = $$v
      },
      expression: "showmods"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "网页H5",
      "value": "h5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信小程序",
      "value": "xcx"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmods == 'h5'),
      expression: "showmods == 'h5'"
    }]
  }, [_c('div', {
    staticClass: "qrtits"
  }, [_vm._v("\n        网页通用:\n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "微信 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "抖音 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/douyin.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "支付宝 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/alipayx.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "今日头条 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/jrtt.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    ref: "qrCodeDiv",
    staticClass: "qrcodeDiv"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmods == 'xcx'),
      expression: "showmods == 'xcx'"
    }]
  }, [_c('div', {
    staticClass: "qrtits"
  }, [_vm._v("微信小程序")]), _vm._v(" "), _c('div', {
    ref: "qrCodeDivx",
    staticClass: "qrcodeDiv"
  })]), _vm._v(" "), (_vm.showtips == true) ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("温馨提示: 文件二维码有可能会失效, 但是文件夹二维码永远不会失效, 还能随时增减文件噢 !!!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aefa200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/file/Qrcode.vue
// module id = 1166
// module chunks = 1